export default __webpack_public_path__ + "static/media/list_main_15_1.11489cb0.png";